import { useUserStore } from "@/App/user/user.store";

export const getUserOptionsKey = (): string => `${useUserStore().user?.id ?? "none"}_options`;
